import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from "vue";
import { usePremCalcService } from "./services/premCalcService";
import { usePremCalcStore } from "./store/premCalcStore";
import Form from './components/form.vue';
import CountryInfo from "./components/countryInfo/countryInfo.vue";
import Disclaimer from "./components/disclaimer.vue";
import ImportantNote from "./components/importantNote.vue";
import ShortCalculation from "./components/calculations/shortCalculation.vue";
import LongCalculation from "./components/calculations/longCalculation.vue";
import GuaranteeModal from "@premcalc/components/calculations/guaranteeModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const premCalcService = usePremCalcService();
const store = usePremCalcStore();

onMounted(() => {
  premCalcService.getViewmodel();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Form),
    (_unref(store).currentCountryInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(CountryInfo),
          (_unref(store).currentCountryInfo?.disclaimer)
            ? (_openBlock(), _createBlock(Disclaimer, { key: 0 }))
            : _createCommentVNode("v-if", true),
          (_unref(store).currentCountryInfo?.importantNote?.description)
            ? (_openBlock(), _createBlock(ImportantNote, { key: 1 }))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    (_unref(store).shortCalculation && !_unref(store).noCalculation && !_unref(store).longCalculation)
      ? (_openBlock(), _createBlock(ShortCalculation, { key: 1 }))
      : _createCommentVNode("v-if", true),
    (_unref(store).longCalculation && !_unref(store).noCalculation && !_unref(store).shortCalculation)
      ? (_openBlock(), _createBlock(LongCalculation, { key: 2 }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})